import _ from 'lodash';

import View from '../../_components/view/view.js';
import newsMgrItemTpl from './news-item.tpl.html';
import './news-item.styles.less';

class NewsItem extends View {

	constructor (data, options) {
		super(newsMgrItemTpl, data, _.extend(options, {
				viewClass: 'news-item'
			})
		);
	}

	uiElements() {
		return _.extend(super.uiElements(), {

		});
	}

	render(data) {
		super.render(data);
	}


	/*onShow() {

	}*/


}

export default NewsItem;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/news-section/news-item/news-item.view.js